import { IRider, IPartialAPISParty, IPartialAPISPartyOption, IFullFlight } from "@vmosolutions/oc-interfaces";
import { RidersForm } from "./RidersForm";

import Accordion, { AccordionProps } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface IRidersAccordionProps {
  selectedRider: IPartialAPISParty;
  updateRiderList?: (rider: IRider, mode: "create" | "update" | "delete") => void;
  accordionProps: Partial<AccordionProps>;
  // setActiveModal?: (activeModal: IActiveModal) => void;
  ridersOnFlight: IRider[];
  flightId: string;
  windowId: string;
  ridersOptions?: IPartialAPISPartyOption[];
  setLoadedFlight: (flightValues: IFullFlight) => void;
}

/**
 * Main form to select operator (to edit in OperatorForm)
 */
export const RidersAccordion = (props: IRidersAccordionProps): JSX.Element => {
  const {
    selectedRider,
    updateRiderList,
    accordionProps,
    // setActiveModal,
    ridersOptions,
    ridersOnFlight,
    flightId,
    windowId,
    setLoadedFlight,
  } = props;

  return (
    <Accordion {...accordionProps} className="accordian">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <span className="form_subtitle">{selectedRider ? "Modify Rider" : "Add Rider"}</span>
        {/* Rider */}
      </AccordionSummary>
      <AccordionDetails>
        <RidersForm
          selectedRider={selectedRider}
          ridersOptions={ridersOptions}
          updateRiderList={updateRiderList}
          ridersOnFlight={ridersOnFlight}
          flightId={flightId}
          windowId={windowId}
          setLoadedFlight={setLoadedFlight}
        />
      </AccordionDetails>
    </Accordion>
  );
};
